import { useTheme } from "@mui/material";
import { ScoreCounter } from "@src/appV2/redesign/EmergencyCredits/components/ScoreCounter";

export interface ScoreDisplayProps {
  /**
   * The starting score value
   */
  startScore: number;
  /**
   * The current end score to animate to
   */
  currentEndScore: number;
  /**
   * Whether the counter should be animating
   */
  animationEnabled: boolean;
  /**
   * Duration of the score counter animation in milliseconds
   */
  duration: number;
}

export function ScoreDisplay(props: ScoreDisplayProps) {
  const { startScore, currentEndScore, animationEnabled, duration } = props;
  const theme = useTheme();

  const color =
    currentEndScore < 0
      ? (theme.palette.intent?.error.text ?? theme.palette.error.main)
      : theme.palette.text.primary;

  return (
    <ScoreCounter
      startValue={startScore}
      endValue={currentEndScore}
      animationEnabled={animationEnabled}
      color={color}
      duration={duration}
    />
  );
}
